module.exports = __webpack_public_path__ + "e9a733a8f073b03c4a073599aa37561e.svg";